import Chip from "components/common/Chip";
import React from "react";

type PROPS = {
  label?: string;
  status: number;
};

const ApplyStatusChip: React.FC<PROPS> = (props) => {
  const label = props.label ?? "";
  const status = props.status;

  const getColor = (status: number) => {
    /** 申請ステータス (0：承認待ち, 1：承認済み, 2：否認, 3：即時承認)*/
    switch (status) {
      case 0:
        return "#fb545a";
      case 1:
        return "#4a88cb";
      case 2:
        return "#6c6c6c";
      case 3:
        return "#4a88cb";
      default:
        return "";
    }
  };

  return <Chip text={label} width="5rem" color={getColor(status)} />;
};

export default ApplyStatusChip;
